// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__7TWdi","modalContent":"style_modalContent__4NRtg","top":"style_top__Md7T+","close":"style_close__n9-eu"};